import classNames from "classnames";
import { WithChildren, WithClassName, WithOnClick } from "types";
import styles from "./overlay.module.scss";

interface Props extends WithChildren, WithClassName, WithOnClick {
  isVisible: boolean;
}

export const Overlay = ({ children, className, onClick, isVisible }: Props) => (
  <div
    className={classNames(
      styles.overlay,
      isVisible && styles.visible,
      className
    )}
    onClick={onClick}
  >
    {children}
  </div>
);
